import axios from 'axios'
import { ApiConfig } from '../../../../../config/api'

export const getAsnBatches = (
  page: number = 0,
  pageSize: number = 5,
  asnId: number,
  lpn?: string,
  batchNumber?: string,
  skuId?: number,
  batchStateIds?: number[]
) => {
  const url = new URL(`${ApiConfig.AsnApi}/${asnId}/batches`)

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (lpn) {
    url.searchParams.set('lpn', lpn)
  }

  if (batchNumber) {
    url.searchParams.set('batchNumber', batchNumber)
  }

  if (skuId) {
    url.searchParams.set('skuId', skuId.toString())
  }

  if (batchStateIds && batchStateIds.length > 0) {
    batchStateIds.forEach((id) => url.searchParams.append('batchStateId', id.toString()))
  }

  return axios.get(url.toString())
}
